import {useContext, useEffect, useState} from "react";
import { AuthContext, SignInCredentials, SignUpCredentials } from "../../../context/AuthContext.tsx";
import { useStyles } from "./useLoginStyles.ts";
import { Grid } from "antd";
import { AxiosError } from "axios";
import { safeLocalStorage } from "../../../util/safeStorage.ts";

const { useBreakpoint } = Grid;

export const useLogin = () => {
    const[hasRedirect, setHasRedirect] = useState(true)
    const { error: authError, signIn } = useContext(AuthContext);
    const screens = useBreakpoint();
    const styles: { [key: string]: React.CSSProperties } = useStyles(screens);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        // Check for magic link redirects only
        const magicLinkRedirect = safeLocalStorage.getItem('appRedirectPath');
        
        // Only show loader if we have a magic link redirect
        // Check if current URL has magic link parameters to validate it's actually a magic link
        const currentUrl = new URL(window.location.href);
        const hasParams = currentUrl.searchParams.has('param2') || currentUrl.searchParams.has('id') || currentUrl.searchParams.has('target');
        
        if (magicLinkRedirect && hasParams) {
            setHasRedirect(true);
        } else {
            // Clean up any stale magic link redirects
            if (magicLinkRedirect && !hasParams) {
                safeLocalStorage.removeItem('appRedirectPath');
            }
            setHasRedirect(false);
        }
    }, [])

    const onSubmit = async (values: SignInCredentials | SignUpCredentials) => {
        try {
            setError(null);
            await signIn(values);
        } catch (err) {
            if (err instanceof AxiosError && err.response?.status === 401) {
                setError("Ungültige E-Mail oder ungültiges Passwort. Bitte versuchen Sie es erneut.");
            } else {
                setError("Ein Fehler ist aufgetreten. Versuchen Sie es später noch einmal.");
            }
        }
    };

    return {
        onSubmit,
        styles,
        error,
        authError,
        hasRedirect
    };
};
